import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSalesOrderCreate,
  detail: routeSalesOrderDetail,
  home: routeSalesOrdersHome,
  root: routeSalesOrdersRoot,
} = createDoctypeRoutes({
  createName: 'new-sales-order',
  createPath: 'new-sales-order',
  detailName: 'salesOrderDetail',
  doctype: DOCTYPES.SALES_ORDER,
  homeName: 'sales-orders-home',
  path: 'sales-orders',
  views: {
    create: async () => await import('@/components/viewsExternal/salesOrders/AddSalesOrder.vue'),
    detail: async () => await import('@/components/viewsExternal/salesOrders/ViewSalesOrder.vue'),
    list: async () => await import('@/components/viewsExternal/salesOrders/SalesOrderView.vue'),
  },
})

export { routeSalesOrderCreate, routeSalesOrderDetail, routeSalesOrdersHome, routeSalesOrdersRoot }
